import data from '../../FakeData/index.json'

function PostHeadingAndOtherStuff({ PostName, date, time, author, cateogary }) {
    return (
        <div className="blog-title px-md-5">
            <h1 className="title-big">{PostName}</h1>
            <ul className="blog-list">
                <li>
                    <p> Posted on <strong>{date}</strong></p>
                </li>
                <li>
                    <p> By <a href={data[0].website}><strong>{author.charAt(0).toUpperCase() + author.slice(1)}</strong></a></p>
                </li>
                {cateogary && <li>
                    <p> Published in <a href={`/cateogary/${cateogary}`}><strong>{cateogary.charAt(0).toUpperCase() + cateogary.slice(1)}</strong></a></p>
                </li>}
                <li>
                    {/* <p> <a href={`/time/${time}`}><strong>{time} min read</strong></a></p> */}
                    <p> <strong> at {time}</strong></p>
                </li>
            </ul>
        </div>
    )
}

export default PostHeadingAndOtherStuff
